import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-metadata-business-terms mt-2" },
    [
      _c(
        "b-form",
        {
          ref: "form",
          staticClass: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
          },
        },
        [
          _c(VTextField, {
            attrs: {
              outlined: "",
              small: "",
              dense: "",
              placeholder: _vm.$t("my_tasks.modals.type_search") + "a",
              "prepend-inner-icon": "icon-search",
            },
            on: {
              keyup: function () {
                _vm.filter = _vm.inputSearch
              },
            },
            model: {
              value: _vm.inputSearch,
              callback: function ($$v) {
                _vm.inputSearch = $$v
              },
              expression: "inputSearch",
            },
          }),
          _c(VDataTable, {
            key: _vm.bterms,
            staticClass: "table-inca",
            attrs: {
              striped: "",
              responsive: "",
              id: "tableBusinessTerm",
              items: _vm.newColumnFields,
              headers: _vm.headers,
              busy: _vm.isLoading,
              "no-border-collapse": true,
              "sticky-header": true,
              search: _vm.filter,
              "hide-default-footer": true,
              page: _vm.pagination.current,
              "items-per-page": _vm.pagination.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-busy",
                  fn: function () {
                    return [_c("base-loading")]
                  },
                  proxy: true,
                },
                _vm.userBelongToDomain &&
                _vm.isChangeRequest !== _vm.TYPE_CHANGE_METADA.VIEWER_ONLY
                  ? {
                      key: "item.navigator",
                      fn: function (ref) {
                        var item = ref.item
                        var index = ref.index
                        return [
                          item.fields.business_term.displayName
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca ml-1",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openBusinessTerm(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-view"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isChangeRequest !==
                            _vm.TYPE_CHANGE_METADA.VIEWER_ONLY &&
                          (_vm.isCurrentDataOperatorLogged ||
                            _vm.userHasRole(_vm.rolesINCA.ORG_DATA_STEWARD) ||
                            _vm.userHasRole(_vm.rolesINCA.PLATFORM_STEWARD))
                            ? _c(
                                VBtn,
                                {
                                  ref: "button",
                                  staticClass: "btn-icon-inca ml-1",
                                  attrs: {
                                    icon: "",
                                    disabled: _vm.validUserAccess,
                                    id: "popover-reactive-" + index,
                                    small: "",
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-edit"),
                                  ]),
                                  _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "popover-reactive-" + index,
                                      },
                                    },
                                    [_vm._v("Assign business term")]
                                  ),
                                  _c(
                                    "b-popover",
                                    {
                                      ref: "popover-reactive-" + index,
                                      attrs: {
                                        target: "popover-reactive-" + index,
                                        triggers: "click",
                                        placement: "auto",
                                        id: "popover-reactive-" + index,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "close",
                                                    attrs: {
                                                      "aria-label": "Close",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onClose(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-inline-block",
                                                        attrs: {
                                                          "aria-hidden": "true",
                                                        },
                                                      },
                                                      [_vm._v("×")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" Business Term"),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                label: "Shared",
                                                "label-for":
                                                  "popover-input-1-" + index,
                                                "label-cols": "6",
                                              },
                                            },
                                            [
                                              _c("b-form-checkbox", {
                                                model: {
                                                  value: _vm.showShared,
                                                  callback: function ($$v) {
                                                    _vm.showShared = $$v
                                                  },
                                                  expression: "showShared",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                label: "Domain",
                                                "label-for":
                                                  "popover-input-1-" + index,
                                                "label-cols": "6",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  options: _vm.selectDomain,
                                                  size: "sm",
                                                  disabled: _vm.showShared,
                                                },
                                                model: {
                                                  value: _vm.kdomain,
                                                  callback: function ($$v) {
                                                    _vm.kdomain = $$v
                                                  },
                                                  expression: "kdomain",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                label: "Subdomain",
                                                "label-for":
                                                  "popover-input-2-" + index,
                                                "label-cols": "6",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  options: _vm.filterSubdomain,
                                                  size: "sm",
                                                  disabled: _vm.showShared,
                                                },
                                                model: {
                                                  value: _vm.ksubdomain,
                                                  callback: function ($$v) {
                                                    _vm.ksubdomain = $$v
                                                  },
                                                  expression: "ksubdomain",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                label: "Business Term",
                                                "label-for":
                                                  "popover-select-" + index,
                                                "label-cols": "6",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                ref: "popover-select-" + index,
                                                attrs: {
                                                  id: "popover-select-" + index,
                                                  options:
                                                    _vm.filterBusinessTerm(
                                                      item
                                                    ),
                                                  size: "sm",
                                                },
                                                model: {
                                                  value: _vm.input1Return,
                                                  callback: function ($$v) {
                                                    _vm.input1Return = $$v
                                                  },
                                                  expression: "input1Return",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClose(index)
                                                },
                                              },
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOk(item)
                                                },
                                              },
                                            },
                                            [_vm._v("Ok")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isChangeRequest !==
                            _vm.TYPE_CHANGE_METADA.VIEWER_ONLY &&
                          (_vm.isCurrentDataOperatorLogged ||
                            _vm.userHasRole(_vm.rolesINCA.ORG_DATA_STEWARD) ||
                            _vm.userHasRole(_vm.rolesINCA.PLATFORM_STEWARD))
                            ? _c(
                                VBtn,
                                {
                                  ref: "button",
                                  staticClass: "btn-icon-inca ml-1",
                                  attrs: {
                                    disabled: _vm.validUserAccess,
                                    id: "popover-reacDel-" + index,
                                    small: "",
                                    icon: "",
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-delete"),
                                  ]),
                                  _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "popover-reacDel-" + index,
                                      },
                                    },
                                    [_vm._v("delete business term")]
                                  ),
                                  _c(
                                    "b-popover",
                                    {
                                      ref: "popover-reacDel-" + index,
                                      attrs: {
                                        target: "popover-reacDel-" + index,
                                        triggers: "click",
                                        placement: "auto",
                                        id: "popover-reacDel-" + index,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "close",
                                                    attrs: {
                                                      "aria-label": "Close",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onClosedelete(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-inline-block",
                                                        attrs: {
                                                          "aria-hidden": "true",
                                                        },
                                                      },
                                                      [_vm._v("×")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " Do you want to unassign the business term?"
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClosedelete(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteRecord(index)
                                                },
                                              },
                                            },
                                            [_vm._v("Ok")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    }
                  : {
                      key: "item.navigator",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          item.fields.business_term.displayName
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca ml-1",
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openBusinessTerm(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-view"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
              ],
              null,
              true
            ),
          }),
          _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
          _c(VAlert, { attrs: { dense: "", type: "info" } }, [
            _vm._v(_vm._s(_vm.leyenda)),
          ]),
          _vm.userBelongToDomain &&
          _vm.isChangeRequest !== _vm.TYPE_CHANGE_METADA.VIEWER_ONLY &&
          (_vm.isCurrentDataOperatorLogged ||
            _vm.userHasRole(_vm.rolesINCA.ORG_DATA_STEWARD) ||
            _vm.userHasRole(_vm.rolesINCA.PLATFORM_STEWARD))
            ? _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "active ml-2",
                      attrs: {
                        dense: "",
                        rounded: "",
                        outlined: "",
                        color: "secondary",
                        disabled: _vm.validUserAccess,
                        id: "popover-save-",
                        type: "submit",
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-save"),
                      ]),
                      _vm._v("Save business terms"),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }